export const enumValues = <T>(enumerable: T): T[keyof T][] => {
  const values = Object.values(enumerable);
  const isStringEnum = values.every(value => typeof value === 'string');

  return isStringEnum ? values : values.filter(value => typeof value !== 'string');
};
